import React from 'react'
import { FieldValues, useForm } from 'react-hook-form';
import { AccountValidationSchema } from './AccountValidation';
import { yupResolver } from '@hookform/resolvers/yup';
import { useEffect } from 'react';
import { useRecoilState } from 'recoil';
import { toast } from 'react-toastify';
import { Button, Grid } from '@mui/material';
import { LoadingButton } from '@mui/lab';
import { UserAtom } from '../../../State/user.Atom';
import { UpdateAccountDetailsDto, AccountDetailsForm } from '../../../Component/Model/SignIn';
import { Auth } from '../../../Component/Api/Auth/AuthService';
import AppTextInput from '../../../Component/Common/Components/FormValidationInputs/AppTextInput';


export const AccountDetailsTabForm = () => {

    const CurrentValidationSchema = AccountValidationSchema[0];
    const [user, setUser] = useRecoilState(UserAtom);
    const [usernameText, setUsernameText] = React.useState<string>("Change Username");
    const [disableUsername, setDisableUsername] = React.useState<boolean>(true);

    const { control, reset, handleSubmit, formState: { isSubmitting } } = useForm({
        mode: 'all',
        resolver: yupResolver(CurrentValidationSchema)
    })

    const UserInitialValues: AccountDetailsForm = {
        contactName: user.contactName,
        email: user.email,
        telephone: user.telephone,
        username: user.username,
    }

    const disableUserNameFunction = () => {
        if (disableUsername === true) setUsernameText("Cancel");
        if (disableUsername === false) setUsernameText("Change Username");
        setDisableUsername(!disableUsername);
    }

    const handleDataSubmit = async (data: FieldValues) => {
        try {
            const requestValues: UpdateAccountDetailsDto = {
                contactName: data.contactName,
                email: data.email,
                telephone: data.telephone,
                username: data.username,
                changeUsername: !disableUsername,
                isFirstTimeLogin: user.isFirstTimeLogin
            }
            Auth.updateAccountDetails(requestValues).then(result => {
                toast.success('Account Details Updated');
                setUser({
                    ...user,
                    contactName: data.contactName,
                    email: data.email,
                    telephone: data.telephone,
                    username: data.username
                });
            }).catch(error => {
                const errorMessage = error.response?.data || 'Failed to update account details';
                console.error('Error updating account details:', errorMessage);
                toast.error(errorMessage);
            })
        } catch (error) {
            console.log(error)
        }
    }

    useEffect(() => {
        reset(UserInitialValues);
    }, [])

    return (
        <>
            <form onSubmit={handleSubmit(handleDataSubmit)} key={1}>
                <Grid container mb={2} spacing={2}>
                    <Grid item xs={12} sm={12} md={6}>
                        <AppTextInput control={control} name="contactName" label="Contact Name" />
                    </Grid>
                    <Grid item xs={12} sm={12} md={6}>
                        <AppTextInput control={control} name="telephone" label="Telephone" />
                    </Grid>
                </Grid>
                <Grid container mb={2} spacing={2}>
                    <Grid item xs={12} sm={12} md={6}>
                        <AppTextInput control={control} name="email" label="Email" />

                    </Grid>
                    <Grid item xs={12} sm={12} md={6}>
                        <AppTextInput control={control} name="username" label="Username" disabled={disableUsername} />
                    </Grid>
                </Grid>
                <Grid container mb={2} spacing={2}>
                    <Grid item xs={12} sm={12} md={6}>
                        <LoadingButton color="primary" type="submit" loading={isSubmitting} variant="contained">
                            Save
                        </LoadingButton>
                    </Grid>
                    <Grid item xs={12} sm={12} md={6}>
                        <Button color="primary" variant="contained" onClick={() => { disableUserNameFunction() }}>
                            {usernameText}
                        </Button>
                    </Grid>
                </Grid>
            </form>
        </>
    )
}

